module.exports = __webpack_public_path__ + "static/media/ESP.2f1696bc.svg";